import {generateStyleClasses, styleHelper} from "../../helpers/commonFunctions";
import {TextLineItem} from "../../interfaces/textLine/TextLine.type";
import useHintStore from "../../store/hintStateStore";
export default function TextLineContainer({
                                                       items,
                                                   }: {
    items: TextLineItem[];
}) {

    const linkHandler = (link: string) => {
        window.location.href = link;
    };

    return (
        <div className={`vas-w-100 vas-py-2 vas-px-3`}>
            <div>
                {items?.map((item: TextLineItem, idx: number) => {
                    return <div key={idx} onClick={() => {
                        item?.link && linkHandler(item.link)
                    }} className={`${item?.link ? 'pointerCursor' : ''} vas-d-inline vas-me-1 ${generateStyleClasses(item.style)}`}>{item.text}</div>
                })}
            </div>
        </div>
    );
}
